import {Component, inject, signal, ViewChild} from '@angular/core';
import {FormsModule, NgForm, ReactiveFormsModule} from "@angular/forms";
import {ConfirmDialogService} from '../../../shared/commons/dialog/confirm-dialog/confirm-dialog.service';
import {NgbActiveModal, NgbPagination} from '@ng-bootstrap/ng-bootstrap';
import {Page, UserOfficialDto} from '../../../../generated-model/model';
import {UserRest} from '../../../service/UserRest';
import {ToastService} from '../../../shared/commons/toast/toast-service';
import {emailPattern} from '../../../app.constants';
import {DecimalPipe, NgForOf, NgIf} from '@angular/common';
import {HasAnyRoleDirective} from '../../../auth/has-any-role.directive';
import {NotFoundComponent} from '../../../shared/not-found/not-found.component';
import {IgnoreNullHttpParams} from '../../../shared/Ignore-null-http-params';
import {filter} from 'rxjs/operators';

@Component({
  selector: 'app-manage-add-official-user-modal',
  standalone: true,
  imports: [
    FormsModule,
    ReactiveFormsModule,
    NgForOf,
    NgIf,
    NgbPagination,
    NotFoundComponent
  ],
  templateUrl: './manage-add-official-user-modal.component.html',
  styleUrl: './manage-add-official-user-modal.component.scss'
})
export class ManageAddOfficialUserModalComponent {

  @ViewChild('form') form: NgForm

  prefix = ''
  confirmDialogService = inject(ConfirmDialogService)
  public activeModal = inject(NgbActiveModal);
  userService = inject(UserRest)
  toastService = inject(ToastService)
  term = ''
  disable = signal(false)
  protected readonly emailPattern = emailPattern;
  listData = signal<UserOfficialDto[]>([])
  pageData = signal<Page<UserOfficialDto>>({number: 1, size: 10})

  search(number = 1) {
    const pageRequest = {page: number - 1, size: this.pageData().size, sort: 'createdDate,desc'}
    const params = IgnoreNullHttpParams.fromObject({term: this.term})
      .set('page', pageRequest.page)
      .set('size', pageRequest.size)
    this.userService.searchSsoUser(params).subscribe(data => {
      this.pageData.set(data)

    }, error => {
      console.log('error')
    })
  }

  save(item: UserOfficialDto) {
    this.confirmDialogService.open({content: 'ยืนยันการบันทึกข้อมูล'}).pipe(filter(e => !!e))
      .subscribe(e => {
        this.userService.saveOfficialUser(item).subscribe({
          next: e => {
            this.activeModal.close(true)
            this.toastService.showSuccess('บันทึกข้อมูลสำเร็จ')
          },error:(e)=>{
            const errorMessage = e.error?.message || "มีข้อผิดพลาด";
            this.toastService.showDangerWithMessage(errorMessage)
            console.log(errorMessage)
          }
        })
      })
  }
}
